import React from "react";
import Flagship from "../../core/flagship";
import { Link } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/appActions";
import {
  Header,
  Label,
  Divider,
  Dropdown,
  Input,
  Icon,
  Card,
  Button
} from "semantic-ui-react";
import { throttle, empty, renderFieldValue } from "../../utils/helpers";
import "../../styles/search.scss";

class Favorites extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.search = this.search.bind(this);
    this.getFavorites = this.getFavorites.bind(this);
    this.searchInputChange = this.searchInputChange.bind(this);
    this.searchInputKeyUp = this.searchInputKeyUp.bind(this);
    this.dropdownChange = this.dropdownChange.bind(this);
    this.timer = null;
  }

  getInitialState() {
    return {
      currentFavorites: empty(this.props.location.query.search)
        ? ""
        : this.props.location.query.search,
      currentType: "any",
      currentPage: 1,
      records: {},
      totalPages: 1,
      loading: true,
      hasGottenFavorites: false
    };
  }

  componentDidMount() {
    document.title = "Flagship / Favorites";
  }

  componentWillMount() {
    // Call API
    if (!empty(this.props.userId) && this.props.userId !== 0) {
      this.getFavorites();
    }
    setTimeout(Flagship.closeSidebarNav, 500);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.route.type !== this.props.route.type) {
      this.setState(this.getInitialState(), this.getFavorites);
    }
  }

  getFavorites() {
    let type = !empty(this.props.route.type) ? this.props.route.type : "any";

    let self = this;

    Flagship.get(
      "search/" + type + "/" + this.state.currentPage,
      {
        search: this.state.currentFavorites,
        onlyFavorites: self.props.userId
      },
      function(response) {
        if (response.data.success === true) {
          self.setState({
            records: response.data.results,
            loading: false,
            hasGottenFavorites: true
          });
        } else {
          Flagship.error("Error getting records from Flagship API server.");
        }
      },
      function(err) {
        Flagship.error(
          "Error getting records from Flagship API server: " + err
        );
        Flagship.redirect("/login");
      }
    );
  }

  search(e) {
    e.persist();
    let filterFavorites = this.filterFavorites;
    this.timer = throttle(
      function() {
        filterFavorites(e.target.value);
      },
      500,
      this.timer
    );
  }

  searchInputKeyUp(e) {
    if (e.which === 13) {
      this.setState(
        {
          loading: true
        },
        this.getFavorites()
      );
    }
  }

  searchInputChange(e) {
    this.setState({
      currentFavorites: e.target.value
    });
  }

  dropdownChange(e, data) {
    if (data.value === "all") {
      Flagship.redirect("/search?search=" + this.state.currentFavorites);
    } else {
      this.setState({
        currentType: data.value
      });
    }
  }

  render() {
    const getCardHeading = (name, key, type, market) => {
      let icon = "exclamation";
      switch (type) {
        case "client":
          icon = "briefcase";
          break;
        case "rfp":
          icon = "dollar";
          break;
        case "io":
          icon = "rocket";
          break;
      }

      return (
        <div>
          <h3 className="blue-text">
            <Icon
              className="feed-icon"
              disabled
              size="large"
              color="grey"
              name={icon}
            />
            {type === "rfp" || type === "io" ? "#" + key : name}
          </h3>
          <h4 style={{ marginTop: "0px" }}>
            {type === "rfp" || type === "io" ? name : market}
          </h4>
        </div>
      );
    };

    let options = [
      { text: "All Favorites", value: "any" },
      { text: "Favorite Clients", value: "client" },
      { text: "Favorite RFPs", value: "rfp" },
      { text: "Favorite IOs", value: "io" },
      { text: "Search All Records", value: "all" }
    ];

    return (
      <div className="fade-in">
        <div id="view-header-section">
          <h1 className="view-title">My Favorites</h1>
          <div style={{ marginTop: "1em" }}>
            <Dropdown
              className="search-record-type"
              selection
              placeholder="Select..."
              options={options}
              value={this.state.currentType}
              onChange={this.dropdownChange}
            />
            <Input
              type="search"
              size="large"
              autoFocus={true}
              value={this.state.currentFavorites}
              className="search-input"
              placeholder="Search Favorites..."
              onChange={this.searchInputChange}
              onKeyUp={this.searchInputKeyUp}
            />
          </div>
        </div>
        <Divider />

        {this.state.hasGottenFavorites === false ? (
          <Button
            onClick={this.getFavorites}
            primary
            content="Show My Favorites"
          />
        ) : (
          ""
        )}
        {!empty(this.state.records) ? (
          <div>
            {!empty(this.state.records.client) &&
            (this.state.currentType === "any" ||
              this.state.currentType === "client") ? (
              <div>
                <Header as="h2" className="white-text cf">
                  Clients
                </Header>
                <Card.Group className="search-results cf">
                  {this.state.records.client.map(function(item, i) {
                    return (
                      <Card
                        className="single-search-result"
                        key={"client-result-" + i}
                      >
                        <Link
                          className="content"
                          to={
                            "/" + item.record_type + "/view/" + item.record_key
                          }
                        >
                          <Card.Content>
                            <Card.Header>
                              {getCardHeading(
                                item.record_name,
                                item.record_key,
                                item.record_type,
                                item.market
                              )}
                            </Card.Header>
                            <Card.Description>
                              {!empty(item.extra1) ? (
                                <div className="search-details">
                                  <Label>
                                    {
                                      Flagship.config.records[item.record_type]
                                        .extra1.label
                                    }
                                  </Label>
                                  <br />
                                  <div className="field-value">
                                    {renderFieldValue(
                                      item.extra1,
                                      Flagship.config.records[item.record_type]
                                        .extra1.validation
                                    )}
                                  </div>
                                </div>
                              ) : null}
                              {!empty(item.extra2) ? (
                                <div className="search-details">
                                  <Label>
                                    {
                                      Flagship.config.records[item.record_type]
                                        .extra2.label
                                    }
                                  </Label>
                                  <br />
                                  <div className="field-value">
                                    {renderFieldValue(
                                      item.extra2,
                                      Flagship.config.records[item.record_type]
                                        .extra2.validation
                                    )}
                                  </div>
                                </div>
                              ) : null}
                              {!empty(item.extra3) ? (
                                <div className="search-details">
                                  <Label>
                                    {
                                      Flagship.config.records[item.record_type]
                                        .extra3.label
                                    }
                                  </Label>
                                  <br />
                                  <div className="field-value">
                                    {renderFieldValue(
                                      item.extra3,
                                      Flagship.config.records[item.record_type]
                                        .extra3.validation
                                    )}
                                  </div>
                                </div>
                              ) : null}
                            </Card.Description>
                          </Card.Content>
                        </Link>
                      </Card>
                    );
                  })}
                </Card.Group>
                <Divider />
              </div>
            ) : null}

            {!empty(this.state.records.rfp) &&
            (this.state.currentType === "any" ||
              this.state.currentType === "rfp") ? (
              <div>
                <Header as="h2" className="white-text">
                  RFPs
                </Header>
                <Card.Group className="search-results">
                  {this.state.records.rfp.map(function(item, i) {
                    return (
                      <Card
                        className="single-search-result"
                        key={"rfp-result-" + i}
                        href={
                          "/" + item.record_type + "/view/" + item.record_key
                        }
                      >
                        <Link
                          className="content"
                          to={
                            "/" + item.record_type + "/view/" + item.record_key
                          }
                        >
                          <Card.Content>
                            <Card.Header>
                              {getCardHeading(
                                item.record_name,
                                item.record_key,
                                item.record_type,
                                item.market
                              )}
                            </Card.Header>
                            <Card.Description>
                              {!empty(item.extra1) ? (
                                <div className="search-details">
                                  <Label>
                                    {
                                      Flagship.config.records[item.record_type]
                                        .extra1.label
                                    }
                                  </Label>
                                  <br />
                                  <div className="field-value">
                                    {renderFieldValue(
                                      item.extra1,
                                      Flagship.config.records[item.record_type]
                                        .extra1.validation
                                    )}
                                  </div>
                                </div>
                              ) : null}
                              {!empty(item.extra2) ? (
                                <div className="search-details">
                                  <Label>
                                    {
                                      Flagship.config.records[item.record_type]
                                        .extra2.label
                                    }
                                  </Label>
                                  <br />
                                  <div className="field-value">
                                    {renderFieldValue(
                                      item.extra2,
                                      Flagship.config.records[item.record_type]
                                        .extra2.validation
                                    )}
                                  </div>
                                </div>
                              ) : null}
                              {!empty(item.extra3) ? (
                                <div className="search-details">
                                  <Label>
                                    {
                                      Flagship.config.records[item.record_type]
                                        .extra3.label
                                    }
                                  </Label>
                                  <br />
                                  <div className="field-value">
                                    {renderFieldValue(
                                      item.extra3,
                                      Flagship.config.records[item.record_type]
                                        .extra3.validation
                                    )}
                                  </div>
                                </div>
                              ) : null}
                            </Card.Description>
                          </Card.Content>
                        </Link>
                      </Card>
                    );
                  })}
                </Card.Group>
                <Divider />
              </div>
            ) : null}

            {!empty(this.state.records.io) &&
            (this.state.currentType === "any" ||
              this.state.currentType === "io") ? (
              <div>
                <Header as="h2" className="white-text">
                  IOs
                </Header>
                <Card.Group className="search-results">
                  {this.state.records.io.map(function(item, i) {
                    return (
                      <Card
                        className="single-search-result"
                        key={"io-result-" + i}
                        href={
                          "/" + item.record_type + "/view/" + item.record_key
                        }
                      >
                        <Link
                          className="content"
                          to={
                            "/" + item.record_type + "/view/" + item.record_key
                          }
                        >
                          <Card.Content>
                            <Card.Header>
                              {getCardHeading(
                                item.record_name,
                                item.record_key,
                                item.record_type,
                                item.market
                              )}
                            </Card.Header>
                            <Card.Description>
                              {!empty(item.extra1) ? (
                                <div className="search-details">
                                  <Label>
                                    {
                                      Flagship.config.records[item.record_type]
                                        .extra1.label
                                    }
                                  </Label>
                                  <br />
                                  <div className="field-value">
                                    {renderFieldValue(
                                      item.extra1,
                                      Flagship.config.records[item.record_type]
                                        .extra1.validation
                                    )}
                                  </div>
                                </div>
                              ) : null}
                              {!empty(item.extra2) ? (
                                <div className="search-details">
                                  <Label>
                                    {
                                      Flagship.config.records[item.record_type]
                                        .extra2.label
                                    }
                                  </Label>
                                  <br />
                                  <div className="field-value">
                                    {renderFieldValue(
                                      item.extra2,
                                      Flagship.config.records[item.record_type]
                                        .extra2.validation
                                    )}
                                  </div>
                                </div>
                              ) : null}
                              {!empty(item.extra3) ? (
                                <div className="search-details">
                                  <Label>
                                    {
                                      Flagship.config.records[item.record_type]
                                        .extra3.label
                                    }
                                  </Label>
                                  <br />
                                  <div className="field-value">
                                    {renderFieldValue(
                                      item.extra3,
                                      Flagship.config.records[item.record_type]
                                        .extra3.validation
                                    )}
                                  </div>
                                </div>
                              ) : null}
                            </Card.Description>
                          </Card.Content>
                        </Link>
                      </Card>
                    );
                  })}
                </Card.Group>
                <Divider />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

Favorites.propTypes = {
  actions: PropTypes.object,
  token: PropTypes.string,
  userId: PropTypes.number
};

function mapStateToProps(state) {
  return {
    token: state.main.token,
    userId: state.main.userId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Favorites);



// WEBPACK FOOTER //
// ./src/components/views/Favorites.js